export default {
    data() {
        return {
            entity: {
              id_subscriber: null,
              name: '',
              security: {
                  'access_with_pin': false,
                  'edit_with_pin': false
              },
              pin: '',
              force_pin_change: false,
              has_pin: false,
              is_child: false,
              id_maturity_rating: null,
              id_image: null,
              is_last_profile: false,
              permissions: {
                  pvrs: 'OWN',
                  periodic_pvrs: 'OWN',
                  selfservice: true,
                  device_settings: true,
                  messages: true,
                  channel_groups: true,
                  vod: true,
              },
            },
            updateFields: [
                'id_subscriber',
                'name',
                'security',
                'pin',
                'force_pin_change',
                'is_child',
                'id_maturity_rating',
                'id_image',
                'permissions',
            ]
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/views/subscriberProfile/mixins/subscriberProfile.js